import React, { useEffect, useState, useMemo } from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { axiosInstance } from "../../axiosInstance";
import { notify } from "../../components/toastify";
import loader from "../../assets/loader.webp";
import Pagination from "../../components/Pagination";
import ConfirmModal from "../../components/ConfirmModal";
import CloseIcon from "@mui/icons-material/Close";
import PeopleOutlineIcon from "@mui/icons-material/PeopleOutline";
import debounce from "lodash-es/debounce";
import { Link } from "react-router";
import AddIcon from "@mui/icons-material/Add";

const ManageSupervisor = () => {
  const [data, setData] = useState([]);
  const [singleData, setSingleData] = useState({});
  const [edittab, setEdittab] = useState(false);
  const [loading, setLoading] = useState(true);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPage, setTotalPage] = useState(1);
  const [isPrevLoading, setIsPrevLoading] = useState(false);
  const [isNextLoading, setIsNextLoading] = useState(false);

  const [companyIdToDelete, setCompanyIdToDelete] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [searchData, setSearchData] = useState("");
  const [, setSearchWord] = useState("");

  const debouncedSearch = useMemo(
    () =>
      debounce((value) => {
        setSearchData(value);
      }, 500),
    [] // Empty dependency array ensures it's created only once
  );

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      debouncedSearch.cancel();
    };
  }, [debouncedSearch]);

  const handleSearch = (e) => {
    const value = e.target.value;
    setSearchWord(value);
    debouncedSearch(value); // Call the debounced function
  };

  const handleDelete = (id) => {
    setCompanyIdToDelete(id);
    setIsModalOpen(true); // Open the confirmation modal
  };

  const handleCloseModal = () => {
    setIsModalOpen(false); // Close the modal
  };

  const fetchData = async (page, data) => {
    try {
      const response = await axiosInstance.post(
        `/api/superadmin/supervisors?page=${page}&searchParam=${data}`,
        {}
      );
      setTotalPage(response?.data?.data?.last_page);
      setData(response?.data?.data?.data);
    } catch (err) {
      console.log("Error fetching data", err);
      notify(err.response.data.message);
    } finally {
      setLoading(false);
      setIsNextLoading(false);
      setIsPrevLoading(false);
    }
  };

  const handleConfirmDelete = async () => {
    try {
      const response = await axiosInstance.delete(
        `/api/superadmin/supervisors/delete/${companyIdToDelete}`
      );

      notify(response?.data?.message, "success");
      fetchData(currentPage, searchData);
    } catch (err) {
      console.log("Error deleting company", err);
      notify(err.response.data.message);
    } finally {
      setIsModalOpen(false);
    }
  };

  const handleEdit = async (id) => {
    try {
      const response = await axiosInstance.get(
        `/api/superadmin/supervisors/show/${id}`
      );
      setSingleData(response?.data?.data);
      setEdittab(true); // Set edit mode
    } catch (err) {
      notify(err.response.data.message);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setSingleData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();

    if (!singleData?.id) {
      notify("Company ID is missing!");
      return;
    }

    const keysToExtract = ["firstname", "lastname", "email", "password"];
    const newSingleData = Object.keys(singleData).reduce((result, key) => {
      if (keysToExtract.includes(key)) {
        result[key] = singleData[key];
      }
      return result;
    }, {});

    // Create FormData object

    try {
      const response = await axiosInstance.put(
        `/api/superadmin/supervisors/update/${singleData?.id}`, // Use PUT for update
        newSingleData
        // { headers: { "Content-Type": "multipart/form-data" } }
      );
      notify(response.data.message, "success");

      // Reset edit mode and refresh data
      setEdittab(false);
      fetchData(currentPage, searchData);
    } catch (error) {
      notify(error.response.data.message);
    } finally {
      setLoading(false);
    }
  };

  // Paginaion code
  const handleCurrentPage = (page, side) => {
    setCurrentPage(page);
  };
  useEffect(() => {
    fetchData(currentPage);
  }, [currentPage]);

  useEffect(() => {
    setCurrentPage(1);
    fetchData(currentPage, searchData);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchData]);

  if (loading) {
    return (
      <div className="w-full h-screen  flex justify-center items-center">
        <img src={loader} alt="loader" className="w-20 " />
      </div>
    );
  }

  return (
    <div className="w-full">
      <div className="flex justify-end pr-4">
        <Link
          to="/superadmin/addsupervisor"
          className="px-4 py-3 text-white rounded-lg bg-blue-500"
        >
          {" "}
          Add Supervisor <AddIcon />
        </Link>
      </div>
      <div className="flex justify-between p-3">
        <h2 className="text-2xl">
          <PeopleOutlineIcon /> Manage Companies
        </h2>
        <input
          placeholder="Search for"
          type="text"
          name="bill_name"
          // id="email"
          value={searchData}
          onChange={handleSearch}
          className="border-2 border-gray-400 w-60 p-2 px-6"
        />
      </div>
      {edittab && (
        <form
          onSubmit={handleEditSubmit}
          className="p-6 bg-lightgray rounded-lg"
        >
          <div className="flex justify-end">
            <CloseIcon
              className="cursor-pointer text-white"
              onClick={() => {
                setEdittab(false);
              }}
            />
          </div>

          <h4 className="text-xl font-semibold mb-3 text-white">
            Spervisor Details
          </h4>
          <div className="flex flex-col lg:flex-row gap-6 flex-wrap">
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none lg:w-[48%]"
              placeholder="First Name"
              type="text"
              name="firstname"
              value={singleData?.firstname || ""}
              onChange={handleChange}
              required
            />
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-teal-500 focus:outline-none lg:w-[48%]"
              placeholder="Last Name"
              type="text"
              name="lastname"
              value={singleData?.lastname || ""}
              required
            />
            <input
              className="border-2 border-gray-300 p-2 rounded-md focus:border-gray-500 focus:outline-none lg:w-[48%]"
              placeholder="Youremail@mail.com"
              type="email"
              name="email"
              value={singleData?.email || ""}
              onChange={handleChange}
              required
            />
          </div>
          <div className="flex justify-center mt-6 text-white font-medium text-xl p-3 bg-darkblue rounded-lg">
            <button type="submit" disabled={loading} className="w-full h-full">
              {loading ? "Updating..." : "Update"}
            </button>
          </div>
        </form>
      )}

      {/* Table for displaying companies */}
      {!edittab && (
        <div>
          <table className="min-w-full bg-white border border-gray-300">
            <thead>
              <tr className="bg-gray-200">
                <th className="py-2 px-4 border-b border-gray-300">NAME</th>
                <th className="py-2 px-4 border-b border-gray-300">EMAIL</th>

                <th className="py-2 px-4 border-b border-gray-300">ACTION</th>
              </tr>
            </thead>
            <tbody>
              {data.map((item) => (
                <tr
                  key={item?.id}
                  className="hover:bg-gray-100 border-b border-gray-300"
                >
                  <td className="py-2 px-4 text-center text-wrap">
                    {item?.firstname} {item?.lastname}
                  </td>
                  <td className="py-2 px-4 text-center text-wrap">
                    {item?.email}
                  </td>
                  <td className="py-2 px-4 flex gap-2 justify-center items-center">
                    <EditIcon
                      onClick={() => handleEdit(item?.id)}
                      className="text-blue-600 cursor-pointer"
                    />
                    <DeleteIcon
                      onClick={() => handleDelete(item?.id)}
                      className="text-red-600 cursor-pointer"
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          <Pagination
            onPageChange={handleCurrentPage}
            totalPage={totalPage}
            currentPage={currentPage}
            setIsNextLoading={setIsNextLoading}
            setIsPrevLoading={setIsPrevLoading}
            isPrevLoading={isPrevLoading}
            isNextLoading={isNextLoading}
          />
        </div>
      )}
      <ConfirmModal
        isOpen={isModalOpen}
        onClose={handleCloseModal}
        onConfirm={handleConfirmDelete}
        text1="Confirm Deletet"
        text2="Are you sure you want to delete the company?"
      />
    </div>
  );
};

export default ManageSupervisor;
